<template>
  <div class="info-page">
    <crumbs title="专题赛企业解决方案" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="100px"
      :disabled="!canEdit"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>详细信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="提供方名称" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入提供方名称"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="联系人" prop="contact">
              <el-input
                v-model="form.contact"
                placeholder="请输入联系人"
                maxlength="15"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系方式" prop="phoneNumber">
              <el-input
                v-model="form.phoneNumber"
                placeholder="请填写手机或固定座机 如：010-87654321"
                maxlength="13"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="通讯地址" prop="address">
              <el-input
                v-model="form.address"
                placeholder="请输入通讯地址"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="提供方性质" prop="providerNatureId">
              <enumerate
                v-model="form.providerNatureId"
                url="/api/ztssolution/getprovidertype"
                placeholder="请选择提供方性质"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="提供方简介" prop="description">
              <el-input
                v-model="form.description"
                type="textarea"
                :autosize="{ minRows: 3 }"
                placeholder="请输入提供方简介"
                maxlength="2000"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="info-page__item">
        <div class="info-page__title">
          <span>对应需求编号和名称</span>
        </div>
        <el-row
          :gutter="10"
          v-for="(item, index) in form.demandList"
          :key="index"
        >
          <el-col :span="8">
            <el-form-item
              label="序号"
              :prop="'demandList.' + index + '.number'"
              :rules="isEmpty('序号不能为空')"
            >
              <el-input
                v-model="item.number"
                placeholder="请输入序号"
                maxlength="10"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="需求编号"
              :prop="'demandList.' + index + '.reqCode'"
              :rules="isEmpty('需求编号不能为空')"
            >
              <el-input
                v-model="item.reqCode"
                placeholder="请输入需求编号"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="需求名称"
              :prop="'demandList.' + index + '.name'"
              :rules="isEmpty('需求名称不能为空')"
            >
              <el-input
                v-model="item.name"
                placeholder="请输入需求名称"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" v-if="canEdit">
          <el-col :span="8">
            <el-form-item label="">
              <el-button
                plain
                type="primary"
                icon="el-icon-plus"
                circle
                @click.prevent="addDemand"
              ></el-button>
              <template v-if="form.demandList.length > 1">
                <el-button
                  plain
                  type="warning"
                  icon="el-icon-minus"
                  circle
                  @click.prevent="removeDemand"
                ></el-button>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="info-page__item">
        <div class="info-page__title">
          <span>提供方负责人及团队成员</span>
        </div>
        <div
          class="team-block"
          v-for="(item, index) in form.teamList"
          :key="index"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                label="序号"
                :prop="'teamList.' + index + '.number'"
                :rules="isEmpty('序号不能为空')"
              >
                <el-input
                  v-model="item.number"
                  placeholder="请输入序号"
                  maxlength="10"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="成员姓名"
                :prop="'teamList.' + index + '.name'"
                :rules="isEmpty('成员姓名不能为空')"
              >
                <el-input
                  v-model="item.name"
                  placeholder="请输入成员姓名"
                  maxlength="10"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="出生年月"
                :prop="'teamList.' + index + '.date'"
                :rules="isEmpty('出生年月不能为空')"
              >
                <el-date-picker
                  v-model="item.date"
                  type="date"
                  placeholder="请选择出生年月"
                  value-format="yyyy-MM-dd"
                  prefix-icon="el-icon-date"
                  style="width: 100%"
                >
                  <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                label="学历"
                :prop="'teamList.' + index + '.education'"
                :rules="isEmpty('学历不能为空')"
              >
                <el-input
                  v-model="item.education"
                  placeholder="请输入学历"
                  maxlength="10"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="职称"
                :prop="'teamList.' + index + '.title'"
                :rules="isEmpty('职称不能为空')"
              >
                <el-input
                  v-model="item.title"
                  placeholder="请输入职称"
                  maxlength="50"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="专业"
                :prop="'teamList.' + index + '.major'"
                :rules="isEmpty('专业不能为空')"
              >
                <el-input
                  v-model="item.major"
                  placeholder="请输入专业"
                  maxlength="10"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                label="负责人简介"
                :prop="'teamList.' + index + '.description'"
                :rules="isEmpty('负责人简介不能为空')"
              >
                <el-input
                  v-model="item.description"
                  type="textarea"
                  :autosize="{ minRows: 3 }"
                  placeholder="请输入负责人简介"
                  maxlength="2000"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="10" v-if="canEdit">
          <el-col :span="8">
            <el-form-item label="">
              <el-button
                plain
                type="primary"
                icon="el-icon-plus"
                circle
                @click.prevent="addTeam"
              ></el-button>
              <template v-if="form.teamList.length > 1">
                <el-button
                  plain
                  type="warning"
                  icon="el-icon-minus"
                  circle
                  @click.prevent="removeTeam"
                ></el-button>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="submit fn-text-center mt-20" v-if="canEdit">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
import CheckObj from "@/utils/check.js";
export default {
  name: "contestSolutionInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否允许编辑
      canEdit: false,
      isEmpty,
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        name: "",
        contact: "",
        phoneNumber: "",
        address: "",
        providerNatureId: "", // integer
        description: "",
        demandList: [
          {
            number: "",
            reqCode: "",
            name: ""
          }
        ],
        teamList: [
          {
            number: "",
            name: "",
            date: "",
            education: "",
            title: "",
            major: "",
            description: ""
          }
        ]
      },
      rules: {
        name: [isEmpty("请输入提供方名称")],
        contact: [
          isEmpty("请输入联系人"),
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkChineseName(value)) {
                return callback(new Error("请输入正确的中文姓名"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        phoneNumber: [
          isEmpty("请输入联系方式"),
          {
            validator: (rule, value, callback) => {
              if (
                value &&
                !CheckObj.checkPhone(value) &&
                !CheckObj.checkTelephone(value)
              ) {
                return callback(new Error("请输入正确的电话号码"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        providerNatureId: [isEmpty("请选择提供方性质", "change")]
      }
    };
  },
  created() {
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    // 添加删除需求
    addDemand() {
      // if (this.form.demandList.length > 10) return;
      this.form.demandList.push({
        number: "",
        reqCode: "",
        name: ""
      });
    },
    removeDemand() {
      this.form.demandList.splice(-1, 1);
    },
    // 添加删除团队
    addTeam() {
      // if (this.form.teamList.length > 10) return;
      this.form.teamList.push({
        number: "",
        name: "",
        date: "",
        education: "",
        title: "",
        major: "",
        description: ""
      });
    },
    removeTeam() {
      this.form.teamList.splice(-1, 1);
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // integer
        providerNatureId,
        // list
        demandList,
        teamList,
        ...others
      } = this.form;
      // 处理字符串 转为数字
      const turnNumber = {
        providerNatureId
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === "" ? -1 : turnNumber[key];
      });
      return {
        ...others,
        ...turnNumber,
        solutionReqRelationList: demandList,
        providerMemberList: teamList
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        // -1 => ""
        providerNatureId,
        // 去分号
        solutionReqRelationList,
        providerMemberList,
        ...others
      } = data;
      // 处理数字 转为字符串
      const turnNumber = {
        providerNatureId
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === -1 ? "" : turnNumber[key];
      });
      return {
        ...others,
        ...turnNumber,
        demandList: solutionReqRelationList,
        teamList: providerMemberList
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("competition", "addSolution", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("competition", "addSolution", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("competition", "getSolutionInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/competitionManage/contestSolutionList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.info-page {
  .team-block {
    margin-top: 25px;
  }
}
</style>
